// extracted by mini-css-extract-plugin
export default {"productCarousel":"F2-z"};